import * as THREE from 'three';

let environment;

// A soft sky/horizon reflection shared by all cars and renderers. No sun disc:
// the real directional light supplies a restrained, broad specular highlight.
// 6 × 32² RGBA texels, about 32 KiB including mipmaps. No scene capture/pass.
function glassEnvironment() {
  if (environment) return environment;
  const size = 32;
  const faces = Array.from({ length: 6 }, (_, face) => {
    const data = new Uint8Array(size * size * 4);
    for (let y = 0; y < size; y++) for (let x = 0; x < size; x++) {
      const u = 2 * (x + 0.5) / size - 1, v = 2 * (y + 0.5) / size - 1;
      // Cube lookup convention: lateral faces have -v as their vertical axis.
      const up = (face === 2 ? 1 : face === 3 ? -1 : -v) / Math.sqrt(1 + u * u + v * v);
      const sky = THREE.MathUtils.smoothstep(up, -0.35, 0.5);
      const horizon = Math.exp(-(((up - 0.12) / 0.38) ** 2));
      const level = 0.24 + sky * 0.48 + horizon * 0.2;
      const offset = (y * size + x) * 4;
      data[offset] = Math.round(level * 0.93 * 255);
      data[offset + 1] = Math.round(level * 0.97 * 255);
      data[offset + 2] = Math.round(level * 255);
      data[offset + 3] = 255;
    }
    return new THREE.DataTexture(data, size, size);
  });
  environment = new THREE.CubeTexture(faces);
  environment.name = 'car-glass-soft-horizon';
  environment.colorSpace = THREE.LinearSRGBColorSpace;
  environment.magFilter = THREE.LinearFilter;
  environment.minFilter = THREE.LinearMipmapLinearFilter;
  environment.generateMipmaps = true;
  environment.needsUpdate = true;
  return environment;
}

export function makeCarGlass() {
  return new THREE.MeshPhongMaterial({
    name: 'car-glass',
    color: '#365766',
    specular: '#18232c',
    shininess: 24,
    envMap: glassEnvironment(),
    reflectivity: 0.75,
    // Multiply the lit surface, so the reflection dims with dusk/night instead
    // of emitting the fixed daytime colors of an additive environment map.
    combine: THREE.MultiplyOperation,
  });
}
